import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { DescriptionSchema } from '../schemas/description';
import type { DetailsSchema } from '../schemas/details';

type UseUpdateEstateDetails = {
  mutationConfig?: MutationConfig<typeof updateEstateDetails>;
};

export interface UpdateEstateDetails extends Partial<Omit<DetailsSchema, 'totalNumberOfRooms'>> {
  id: string;
}

export interface UpdateEstateDescription extends DescriptionSchema {
  id: string;
}

export const updateEstateDetails = ({
  id,
  ...args
}: UpdateEstateDetails | UpdateEstateDescription) => {
  return extractData(api.estates({ id }).details.put(args));
};

export const useUpdateEstateDetails = ({ mutationConfig }: UseUpdateEstateDetails) =>
  useMutation({
    ...mutationConfig,
    mutationFn: updateEstateDetails,
  });
